import i18n from '@shared/i18n'
import { ErrorTypes } from '@shared/models/enums/http'

export class ServerError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = ErrorTypes.SERVER
    this.message = message || i18n.global.t('common.serverError')
  }
}

export class NetworkError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = ErrorTypes.NETWORK
    this.message = message || i18n.global.t('common.networkError')
  }
}

export const createError = (
  type: string,
  message?: string,
  defaulMessage: Error = new Error(i18n.global.t('common.httpError'))
) => {
  switch (type) {
    case ErrorTypes.SERVER:
      return new ServerError(message)
    case ErrorTypes.NETWORK:
      return new NetworkError(message)
    default:
      throw defaulMessage
  }
}
